export default __webpack_public_path__ + "static/media/down-arrow.3241cbd7.svg";